<div class="mt-1">
	<ul class="d-flex justify-content-end pagination">
	  <li class="page-item">
		<a class="page-link color-blue">{{ pagination?.to }} de {{ pagination?.total }}
		</a>
	  </li>
	  <div *ngFor="let item of pagination?.links; let i = index">
		<li class="page-item">
		  <a class="page-link color-blue" *ngIf="i == 0" (click)="prev.emit()">«</a>
		</li>
		<li class="page-item">
		  <a class="page-link color-blue" *ngIf="i != 0 && i != pagination?.links.length - 1"
			(click)="num.emit(item.label)">{{ item.label }}</a>
		</li>
		<li class="page-item">
		  <a class="page-link color-blue" *ngIf="i == pagination?.links.length - 1"
			(click)="next.emit()">»</a>
		</li>
	  </div>
	</ul>
  </div>